// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"59":"admin-assistant","152":"store-account","543":"store-checkout","884":"admin","962":"store"}[chunkId] || chunkId) + "." + {"59":"a0846c46","107":"9485cd01","152":"a7b625ae","233":"a2088f27","543":"828a30d9","884":"e423bc57","962":"1a33e108","977":"70a017b8"}[chunkId] + ".chunk.js";
};